import { AlertManager } from 'react-alert'
import { RouteComponentProps } from 'react-router'
import {
  GeneralStore,
  GENERAL_STORE,
  UserStore,
  USER_STORE
} from 'store'
import { FormConstraints, StyleProps } from 'utilities'

interface MatchParams {
  code: string
}

export type SignUpPageProps = StyleProps & RouteComponentProps<MatchParams> & {
  [GENERAL_STORE]?: GeneralStore
  [USER_STORE]?: UserStore
  alert: AlertManager
}

export type SignupForm = {
  firstName: string
  lastName: string
  password: string
  confirmPassword: string
}

export const signupFormConstraints: FormConstraints<SignupForm> = {
  firstName: {
    presence: true,
    length: {
      minimum: 2
    }
  },
  lastName: {
    presence: true,
    length: {
      minimum: 2
    }
  },
  password: {
    presence: true,
    length: {
      minimum: 2
    }
  },
  confirmPassword: {
    equality: 'password'
  }
}
